export const SEND_RESELLER_TYPE_FAIL = 'la/ui/resellerType/FAIL';
export const SEND_RESELLER_TYPE_REQUEST = 'la/ui/resellerType/REQUEST';
export const SEND_RESELLER_TYPE_SUCCESS = 'la/ui/resellerType/SUCCESS';
